export default __webpack_public_path__ + "9e7c1f72a05c8e9d1e059033dcee48eb.png";